"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _apiFilter = _interopRequireDefault(require("./apiFilter"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ModelAPI = /*#__PURE__*/function () {
  // This is a good default filter map for most models, but could
  // be overriden on ModelAPI subclasses.
  function ModelAPI(cls) {
    (0, _classCallCheck2["default"])(this, ModelAPI);
    this.cls = cls;
  }

  (0, _createClass2["default"])(ModelAPI, [{
    key: "list",
    value: function list(_ref) {
      var _this = this;

      var _ref$filters = _ref.filters,
          filters = _ref$filters === void 0 ? {} : _ref$filters,
          _ref$pagination = _ref.pagination,
          pagination = _ref$pagination === void 0 ? {} : _ref$pagination;
      var url = this.constructor.ENDPOINT;
      var filtersMap = this.constructor.FILTERS_MAP;
      var options = {
        params: _apiFilter["default"].buildParams(filtersMap, _objectSpread({}, filters, {
          page: pagination.page,
          pageSize: pagination.size
        }))
      };
      return this.client.get(url, options).then(function (response) {
        return response.data;
      }).then(function (data) {
        return _objectSpread({}, data, {
          results: data.results.map(function (i) {
            return _this.cls.fromAPI(i);
          })
        });
      });
    }
  }, {
    key: "retrieve",
    value: function retrieve(id) {
      var _this2 = this;

      var url = "".concat(this.constructor.ENDPOINT).concat(id, "/");
      var options = {};
      return this.client.get(url, options).then(function (response) {
        return _this2.cls.fromAPI(response.data);
      });
    }
  }, {
    key: "create",
    value: function create(obj) {
      var _this3 = this;

      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var url = this.constructor.ENDPOINT;
      var data = this.cls.toAPI(obj, fields, excludeFields);
      var options = {};
      return this.client.post(url, data, options).then(function (response) {
        return response.data;
      }).then(function (data) {
        return _this3.cls.fromAPI(data);
      });
    }
  }, {
    key: "client",

    /**
     * The API Client should be defined as a `static` value on the subclass.
     *
     * Example:
     *
     *    static client = ApiClient
     */
    get: function get() {
      if (typeof this.constructor.client === 'undefined') {
        throw Error('You must set `client` as a static property of your ModelAPI class.');
      }

      return this.constructor.client;
    }
  }], [{
    key: "create",
    value: function create(cls) {
      return new this(cls);
    }
  }]);
  return ModelAPI;
}();

exports["default"] = ModelAPI;
(0, _defineProperty2["default"])(ModelAPI, "FILTERS_MAP", {
  // Pagination
  page: _apiFilter["default"].create({
    key: 'page'
  }),
  pageSize: _apiFilter["default"].create({
    key: 'page_size'
  }),
  // Sorting
  ordering: _apiFilter["default"].create({
    key: 'ordering'
  })
});